import * as Yup from 'yup';

export const ExtraStorageFormSchema = Yup.object().shape({
  extraStorages: Yup.array().of(
    Yup.object().shape({
      planName: Yup.string().required('Storage plan name is required'),
      frequency: Yup.number()
        .typeError('Frequency must be a number')
        .positive('Frequency must be positive')
        .required('Frequency is required'),
      creditsPerGB: Yup.number()
        .typeError('Credits per GB must be a number')
        .positive('Credits per GB must be positive')
        .required('Credits per GB is required'),
    })
  ),
});
